// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gamma"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 7.5L6.22222 3.5625L12.8889 16.5V21M13.1152 16L19 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GammaIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'gamma',
    ref,
    icon: element,
  },
));

GammaIcon.displayName = 'GammaIcon';

export default GammaIcon;
